var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAudioPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(.139 100 100)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#7286e9",
    fillOpacity: 0.688
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 138.51802,110.58691 c 8.13051,-5.72831 8.12901,-15.016804 0,-20.744057 L 83.721592,51.236275 C 75.591081,45.507961 69,48.929744 69,58.860165 V 141.5696 c 0,9.93887 6.592588,13.35114 14.721592,7.62389 z",
    fill: "#fdfffc"
  }))));
}

export default SvgAudioPlay;